import { ObjectValues } from "helpers/types";

export const ONE_PAGE_SHORT_SECTIONS = {
  SHORT: 'SHORT'
} as const;

export type IOnePageShortSections = ObjectValues<typeof ONE_PAGE_SHORT_SECTIONS>;